import React from 'react';


const LDAPConnectionIndicator = ({ connected, lastSync }) => {
  return (
    <div className="flex items-center justify-between p-3 bg-card border border-border rounded-lg">
      <div className="flex items-center gap-3">
        <div className={`w-2 h-2 rounded-full ${connected ? 'bg-success animate-pulse' : 'bg-error'}`} />
        <div>
          <p className="text-sm font-medium text-foreground">
            LDAP/Active Directory
          </p>
          <p className="text-xs text-muted-foreground">
            {connected ? 'Verbunden' : 'Nicht verbunden'}
          </p>
        </div>
      </div>
      {connected && lastSync && (
        <div className="text-right">
          <p className="text-xs text-muted-foreground">
            Letzte Synchronisation
          </p>
          <p className="text-xs font-medium text-foreground">
            {lastSync}
          </p>
        </div>
      )}
    </div>
  );
};

export default LDAPConnectionIndicator;